import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../../common/types';
import { SMLButton } from '../../../components/primitives/SMLButton';
import { StudioActionError } from '../../studio/StudioActionError';
import { profileEntryMessages as e } from '../entry/profileEntryMessages';
import { useKitProfileShortcut } from './useKitProfileShortcut';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the Profile; each part uses its own slice of it */
import styles from '../Profile.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface KitProfileUseReleaseProps {
  accountId: number;
  catalogItemUuid: string;
  title: string;
}

/**
 * "Use this release for my profile" at the top of the Profile images group of the Kit tab (design
 * c3): the Spotify header and the two banners of the Profile from the blurred cover of this
 * release, in its look (`POST .../artist-profile/from-release { catalogItemUuid }`). Free.
 */
const KitProfileUseReleaseComponent: React.FC<KitProfileUseReleaseProps> = ({ accountId, catalogItemUuid, title }) => {
  const intl = useIntl();
  const shortcut = useKitProfileShortcut(accountId);
  const done = shortcut.doneKey === catalogItemUuid;
  return (
    <div className={`${styles.useIt} ${styles.useItWide}`} data-testid="kit-profile-use-release">
      <div className={styles.grow}>
        <b>{intl.formatMessage(e.kitUseTitle)}</b>
        <small>{intl.formatMessage(done ? e.kitUseDone : e.kitUseBody, { title })}</small>
        <StudioActionError feedback={shortcut.feedback} />
      </div>
      {done ? (
        <SMLButton className={styles.sm} onClick={() => shortcut.openProfile()}>
          {intl.formatMessage(e.openProfile)}
        </SMLButton>
      ) : (
        <SMLButton
          variant="primary"
          className={styles.sm}
          disabled={shortcut.isBusy}
          onClick={() => shortcut.use(catalogItemUuid)}
        >
          {intl.formatMessage(e.kitUseIt)}
        </SMLButton>
      )}
    </div>
  );
};

export const KitProfileUseRelease = TypedMemo(KitProfileUseReleaseComponent);
